import { type FC } from 'react';
import { Container, TitleBlock } from '../primitives';

/** A genuine sequence, so numbered steps carry real information here. */
const STEPS = [
  {
    number: '01',
    title: 'Send your plans',
    body: 'Email plans, or just the address and rough measurements. Photos help for repairs and driveways.'
  },
  {
    number: '02',
    title: 'Fixed quote back fast',
    body: 'A written, itemised quote, typically within two working days. No surprises later.'
  },
  {
    number: '03',
    title: 'We box, pour & finish',
    body: 'Set-out, boxing, reinforcing, pour and finish, to the drawings, with inspections coordinated.'
  },
  {
    number: '04',
    title: 'Signed off & ready',
    body: 'Cured, checked and handed over on schedule, ready for framing, cars or the barbecue.'
  }
] as const;

export const Process: FC = () => (
  <section className="border-y border-ink-200 bg-white py-20 sm:py-28">
    <Container>
      <TitleBlock
        sheet="DB-02 - How a job runs"
        title="Plans in. Floor down. No drama."
        lede="The same four steps whether it's one driveway or a builder's yearly programme."
      />
      <ol className="grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((step) => (
          <li key={step.number}>
            <div className="flex items-baseline gap-3">
              <span className="font-mono text-sm text-brand-600">{step.number}</span>
              <span className="h-px flex-1 bg-ink-200" aria-hidden="true" />
            </div>
            <h3 className="font-display mt-4 text-lg font-bold text-ink-900">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-600">{step.body}</p>
          </li>
        ))}
      </ol>
    </Container>
  </section>
);
